import React from "react"
import lendingMapData from "../data/lending-map-data.json"
import { getColors } from "./lending-map"
import findObject from "../helpers/find-object"

// Creates an svg element that contains all patterns required for the lending map
function LendingMapPatterns() {
  var patterns = [] // Initialize patterns array

  // Iterate through the countries that have agreements
  lendingMapData.forEach(dataItem => {
    if (dataItem.agreements.length > 1) {
      // Get the color names and values that apply to the data item
      var { colorNames, colorValues } = getColors(dataItem)

      let patternID = `pattern-stripe-${colorNames.sort().join("-")}`, // Sort colorNames to ensure predictable ids to check against
        patternExists = findObject(patterns, "id", patternID) // Check if the pattern id already exists

      // Ignore duplicate patterns
      if (patternExists) {
        return
      }

      // Push new patterns to array
      patterns.push({
        id: patternID,
        colors: colorValues,
      })
    }
  })

  return (
    <svg
      className="lending-map__patterns"
      xmlns="https://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
    >
      <defs>
        {patterns.map(pattern => {
          return (
            <LendingMapPattern
              key={pattern.id}
              id={pattern.id}
              colors={pattern.colors}
            />
          )
        })}
      </defs>
    </svg>
  )
}

// Creates a single pattern for the LendingMapPatterns() svg
function LendingMapPattern({ id, colors }) {
  const stopsNumber = colors.length,
    patternScale = "2.5", // px value relative to base SVG size
    patternSize = `${colors.length * patternScale}px`

  var stops = [] // Initialize stops array

  // Iterate through the colors
  colors.forEach((color, index) => {
    // Push data to stops array
    // Due to linearGradient behavior, must push a 0% offset stop before each desired stop
    stops.push(
      {
        offset: "0%",
        color: color,
      },
      {
        offset: `${((index + 1) / stopsNumber) * 100}%`,
        color: color,
      }
    )
  })

  return (
    <linearGradient
      id={id}
      gradientUnits="userSpaceOnUse"
      x1="0"
      y1="0"
      x2={patternSize}
      y2={patternSize}
      spreadMethod="repeat"
    >
      {stops.map((stop, index) => {
        return (
          <stop
            key={`stop-${id}-${index}`}
            id={`stop-${id}-${index}`}
            offset={stop.offset}
            style={{ stopColor: stop.color }}
          />
        )
      })}
    </linearGradient>
  )
}

export default LendingMapPatterns
